import React from 'react';
import styled from 'styled-components';

import { ModalContainer, ModalExitIcon } from 'components/core';
import { formatCurrency } from 'shared/helpers/utils';
import type { PosOrderFieldsFragment } from 'src/gql/graphql';

import { InstoreReceiptHeader } from './instore-receipt-header';
import { InstoreReceiptItemDesktop } from './instore-receipt-item-desktop';
import { InstoreReceiptDetails } from './instore-receipt-details';
import { InstoreReceiptTotals } from './instore-receipt-totals';

type InstoreReceiptDesktopProps = {
  posOrder: PosOrderFieldsFragment;
  onClose: () => void;
};

export function InstoreReceiptDesktop({ posOrder, onClose }: InstoreReceiptDesktopProps): JSX.Element {
  const items = posOrder.items ?? [];

  return (
    <Container data-testid='instore-order-receipt-modal-desktop' width={740}>
      <ModalExitIcon onClick={onClose} />
      <ModalContent>
        <InstoreReceiptHeader locationDetails={posOrder.locationDetails} />

        <OrderSummary role='list'>
          {items.map((item, index) => (
            <InstoreReceiptItemDesktop
              // eslint-disable-next-line react/no-array-index-key
              key={`${item.productName}-${index}`}
              productName={item.productName}
              brandName={item.brandName}
              option={item.option}
              quantity={item.quantity}
              formattedPrice={formatCurrency(item.price * item.quantity)}
            />
          ))}
        </OrderSummary>

        <BottomWrapper>
          <InstoreReceiptDetails posOrder={posOrder} />
          <OrderTotalsContainer>
            <InstoreReceiptTotals posOrder={posOrder} />
          </OrderTotalsContainer>
        </BottomWrapper>
      </ModalContent>
    </Container>
  );
}

const Container = styled(ModalContainer)`
  padding: 40px;
  margin: 100px auto;
  transform: none;
  height: auto;
  overflow: auto;
  top: 0;
`;

const BottomWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 78px;
  width: 100%;
`;

const ModalContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const OrderSummary = styled.ul`
  list-style: none;
  margin: 0 0 40px;
  padding: 0 20px;
  border: 1px solid ${({ theme }) => theme.colors.blueGrey[90]};
  border-radius: 8px;
  width: 100%;
`;

const OrderTotalsContainer = styled.div`
  width: 100%;
`;
